import React, { ComponentType, PureComponent } from 'react';

import withContext from './withContext';
import withTextContext from './withTextContext';

const withProgressBar = (loadedProgress = 0) => <P extends object>(
  Component: ComponentType<P & Partial<IContext> & Partial<ITextContext>>
) => {
  class WithProgressBar extends PureComponent<P & Partial<IContext> & Partial<ITextContext> & Partial<ILocaleContext>> {
    componentDidMount() {
      this.handleSelectMethodPayment(loadedProgress);
    }

    handleSelectMethodPayment = (value: number) => {
      const { setProgress } = this.props;

      if (setProgress) {
        setProgress(value);
      }
    };

    render() {
      return <Component {...this.props} />;
    }
  }

  return withContext(withTextContext(WithProgressBar));
};

export default withProgressBar;
